import dayjs from 'dayjs'
import pick from 'lodash/pick'
import set from 'lodash/set'

export const formatModifyServicesResponse = (itinerary, hotel) => {
  const roomStays = {
    ...pick(hotel, [
      'adults',
      'chainCode',
      'children',
      'hotelCode',
      'promoCode',
      'ratePlanCode',
      'ratePlanName',
    ]),
    dateEnd: dayjs(hotel?.endDate).format('YYYY-MM-DD'),
    dateStart: dayjs(hotel?.startDate).format('YYYY-MM-DD'),
    hotelName: hotel?.name,
    roomTypes: {
      numberOfUnits: 1,
      roomTypeCode: hotel?.roomTypeCode,
      roomTypeName: hotel?.roomTypeName,
    },
  }

  const modificationItems =
    itinerary?.itineraryInfo?.modificationItems?.item || []
  const modifiedItemIndex = modificationItems?.findIndex(
    (item) => item?.rph === hotel?.id
  )
  if (modifiedItemIndex !== -1) {
    set(
      itinerary,
      `itineraryInfo.modificationItems.item[${modifiedItemIndex}].hotel.roomStays`,
      roomStays
    )
  }

  return itinerary
}
